"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/APIKeys/components/RequestAPIAccess.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _supportUrls = require('shared/data/supportUrls');
var _user = require('shared/selectors/user');
var _org = require('shared/selectors/org');
var _hooks = require('web/services/hooks');

var _Form = require('web/components/Form');
var _FeedbackModal = require('web/components/FeedbackModal'); var _FeedbackModal2 = _interopRequireDefault(_FeedbackModal);






// The request Support receives, which the person can edit before sending.
 const apiAccessRequest = (accountName, requester) =>
  `Please turn on API access for our account, ${accountName}, so we can create API keys.\n\nRequested by ${requester}.`; exports.apiAccessRequest = apiAccessRequest

/* What someone can do while the account has no API access (F-11): ask
 * Support for it, through the app's own Feedback dialog with the request
 * written out, or read about the API. */
const RequestAPIAccess = ({ orgKey }) => {
  const [isOpen, setIsOpen] = _react.useState.call(void 0, false)
  const accountName = _hooks.useAppSelector.call(void 0, state => _nullishCoalesce(_optionalChain([_org.selectOrgByKey.call(void 0, orgKey, state), 'optionalAccess', _ => _.Name]), () => ( 'our account')))
  const requester = _hooks.useAppSelector.call(void 0, state => {
    const me = _user.selectCurrentUser.call(void 0, state)
    const name = [_optionalChain([me, 'optionalAccess', _2 => _2.FirstName]), _optionalChain([me, 'optionalAccess', _3 => _3.LastName])].filter(Boolean).join(' ')
    return _optionalChain([me, 'optionalAccess', _4 => _4.Email]) ? `${name || me.Email} (${me.Email})` : name
  })

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_Form.Button, { onClick: () => setIsOpen(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}, "Request access" )
      , _react2.default.createElement('a', { className: "blm-btn blm-btn--secondary settings--org-api-keys--learn-more"  , href: _supportUrls.apiIntegrationsUrl, target: "_blank", rel: "noopener noreferrer" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}, "Learn more"

      )
      ,  isOpen && (
        _react2.default.createElement(_FeedbackModal2.default, {
          orgKey: orgKey,
          initialMessage: exports.apiAccessRequest.call(void 0, accountName, requester),
          onClose: () => setIsOpen(false), __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
        )
      )
    )
  )
}

exports. default = RequestAPIAccess
